import renderDict from './renderDict';
import KEY_CODES from '../../../../../../editJournal/constants/keyCodes';
import mergeBullets from '../../../../../../editJournal/slateUtilities/plugins/mergeBullets';
import createNewBulletBellow from '../../../../../../editJournal/slateUtilities/plugins/createNewBulletBellow';
import tabHandler from '../../../../../../editJournal/slateUtilities/plugins/tab';
import mergeULs from '../../../../../../editJournal/slateUtilities/plugins/mergeULs';
import tab from './tab';

export default (params) => {
  const { event, editor } = params;
  const { value } = editor;
  const { anchorBlock, focusBlock, document, selection } = value;
  const { key: focusBlockKey } = focusBlock;
  const { isExpanded } = selection;
  const parent = document.getParent(focusBlockKey);
  const { type: parentType } = parent;
  if (isExpanded) {
    if (
      renderDict[parentType] === 'list_item' &&
      editor.value.fragment.text !== ''
    ) {
      const characterPressed =
        (event.which > 47 && event.which < 91) ||
        (event.which > 95 && event.which < 112) ||
        (event.which > 185 && event.which < 193) ||
        (event.which > 218 && event.which < 223);
      if (
        (event.which === KEY_CODES.ENTER ||
          event.which === KEY_CODES.BACKSPACE ||
          event.which === KEY_CODES.DELETE ||
          characterPressed) &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        if (focusBlock.key !== anchorBlock.key) {
          mergeBullets(editor, event);
        }
        if (
          focusBlock.key === anchorBlock.key &&
          event.which === KEY_CODES.ENTER
        ) {
          if (event.shiftKey) editor.insertText('\n');
          else createNewBulletBellow(editor);
        }
        if (
          focusBlock.key === anchorBlock.key &&
          !(event.which === KEY_CODES.ENTER)
        ) {
          editor.delete();
        }
      }
      if (event.which === KEY_CODES.TAB) {
        const isReturn = tabHandler(event, editor, null);
        if (!isReturn) tab(params);
      }
      mergeULs(editor);
      return true;
    }
  }
  return false;
};
